import styled, { css, keyframes } from 'styled-components'

import { fadeIn } from '@/theme/animations'
import { media } from '@/theme/common'

import { LINK_STROKE_WIDTH } from './linked-columns.constants'

const drawLine = keyframes`
  from {
    stroke-dashoffset: 1;
  }
  to {
    stroke-dashoffset: 0;
  }
`

export const Columns = styled.div(({ theme }) => ({
  '> *': {
    height: '44rem',
  },
  display: 'grid',
  flex: 1,
  gap: theme.space['16'],
  gridTemplateColumns: 'minmax(0, 1fr)',
  minHeight: '48rem',
  position: 'relative',

  [media.up('md')]: {
    '> *': {
      height: '100%',
    },
    gap: theme.space['24'],
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  },
}))

export const Overlay = styled.svg<{ $dimmed: boolean }>(({ theme, $dimmed }) => ({
  [media.down('md')]: {
    display: 'none',
  },
  color: theme.colors.gray800,
  fill: 'none',
  height: '100%',
  left: 0,
  opacity: $dimmed ? 0.2 : 1,
  overflow: 'visible',
  pointerEvents: 'none',
  position: 'absolute',
  top: 0,
  transition: ['color', 'opacity']
    .map((property) => `${property} ${theme.transition.duration.md}`)
    .join(', '),
  width: '100%',
  // Note: above the selected row, which is sticky (z-index 1), so the dot on its edge is not cut in half
  zIndex: 2,
}))

export const Spine = styled.path(
  ({ theme }) => css`
    animation: ${drawLine} ${theme.transition.duration.md} ease-out backwards;
    stroke: currentColor;
    stroke-dasharray: 1;
    stroke-linecap: round;
    stroke-width: ${LINK_STROKE_WIDTH};

    @media (prefers-reduced-motion: reduce) {
      animation: none;
    }
  `,
)

export const Fading = styled.g(
  ({ theme }) => css`
    animation: ${fadeIn} ${theme.transition.duration.md} ease-out backwards;
    animation-delay: calc(var(--index, 0) * 30ms + ${theme.transition.duration.md} / 2);
    stroke: currentColor;
    stroke-linecap: round;
    stroke-width: ${LINK_STROKE_WIDTH};

    circle {
      fill: currentColor;
      stroke: none;
    }

    @media (prefers-reduced-motion: reduce) {
      animation: none;
    }
  `,
)
